<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga w-100">
                <div class="h3Organization w-50">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Templates</h3>
                </div>
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button @click="searchBackEndHandler" class="search-btn">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search"
                                   class="form-control" v-model="search"
                                   placeholder="Search"
                                   autocomplete="off"
                                   @input="searchHandler">
                        </div>
                    </div>

                    <div class="fullInputs mb-4">
                        <div class="oneInput w-100">
                            <select id="filter_dates" class="form-select" v-model="sort" @change="filterHandler">
                                <option value="" disabled>Sort by Date</option>
                                <option value="asc" key="1">Oldest</option>
                                <option value="desc" key="2">Latest</option>
                            </select>
                        </div>
                    </div>

                    <router-link to="/templates/create" id="entities-btn"
                            v-if="permissions.includes('create template') && templates.length > 0"
                            class="text-decoration-none btn-container">Create
                    </router-link>
                </div>
                
            </div>
            <div class="tabcontent">
                
                <div class="table-container" v-if="templates.length > 0">

                    <TableComponent model="templates" name="template" :keys="keys" :thead="thead" :tbody="templates"
                                    updateUrl="/templates/edit"
                                    @sort="sortTemplates"
                                    @update="updateHandler($event)"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="handlePagination($event)" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
                <div class="d-flex h-75 m-auto" v-else>
                    <div v-if="!isSearch"
                         class="d-flex flex-column justify-content-center align-items-center py-3 w-100">
                        <h3 class="w-100 text-center">You don't have any templates yet</h3>
                        <router-link v-if="permissions.includes('create template')" to="/templates/create"
                                     class="setting-action my-2">Create Template
                        </router-link>
                    </div>
                    <div v-else class="d-flex flex-column justify-content-center align-items-center py-3 w-100">
                        <h3 class="w-100 text-center">No Data</h3>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import {useStore} from "vuex";
    import {onMounted, ref} from "vue";
    import repository from "../../../api-services/repository";
    import moment from 'moment';


    export default {
        name: 'template-page',
        components: {TableComponent, 'Pagination': LaravelVuePagination},
        setup() {
            const store = useStore();
            let templates = ref([]);
            let permissions = ref([]);
            let originalTemplates = ref([]);
            let search = ref('');
            let isSearch = ref(false);
            let sort = ref('desc');
            const laravelData = ref({});
            const thead = ref(['Template Name', 'Created at']);
            const keys = ref(['name', 'createdAt']);
            let state = ref(false);

            onMounted(async () => {
                await store.dispatch('activeTap', 'templates');
                permissions.value = await store.state.auth.permissions;
                await getTemplates(true);
            });

            const searchHandler = (e) => {
                isSearch.value = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                // if (serachedValue !== '') {
                //     isSearch.value = true;
                // } else {
                //     isSearch.value = false;
                // }
                // searchedData = originalTemplates.value.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0);
                // templates.value = searchedData;
            };

            const searchBackEndHandler = async (searchFlag = true) => {
                await getTemplates(searchFlag);
            };

            const filterHandler = (e) => {
                let filterType = e.target.value;
                if (filterType === 'asc') {
                    templates.value.sort(function (a, b) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    });
                } else {
                    templates.value.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                }
            };


            const sortTemplates = (e) => {
                let status = !state.value;
                templates.value.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase())) : -(b.id - a.id || b.name.trim().toLowerCase().localeCompare(a.name.trim().toLowerCase()));
                });
                state.value = status;
            };

            const handlePagination = async (pageNumber) => {
                await getTemplates(pageNumber);
            };

            const updateHandler = async (event) => {
                templates.value = templates.value.filter((template) => {
                    return template.id !== event
                })
                await getTemplates(true);
            };

            const getTemplates = async (page = 1) => {

                try {
                    let templatesData = await repository.index('templates', search.value, sort.value, true, page);
                    if (process.env.VUE_ENV === 'development')
                        console.log(templatesData.data.data.data)
                    laravelData.value = templatesData.data.data;
                    templates.value = templatesData.data.data.data;
                    originalTemplates.value = templatesData.data.data.data;

                    templates.value = templates.value.map((temp) => {
                        temp.createdAt = moment(temp.created_at).format('D-MMM-YYYY');
                        return temp;
                    })
                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log({e})
                }

            };

            return {
                templates,
                originalTemplates,
                search,
                sort,
                laravelData,
                keys,
                thead,
                state,
                isSearch,
                updateHandler,
                sortTemplates,
                searchHandler,
                filterHandler,
                getTemplates,
                handlePagination,
                permissions,
                searchBackEndHandler
            }
        }
    }
</script>

<style scoped>
    .table-container :deep(.wide-action-col){
        width:30% !important;
        max-width: unset !important;
        min-width: unset !important;
    }
.table-container :deep(.table-action-text) {
    width: 40% !important;
}

.table-container :deep(.action-left-cell),
.table-container :deep(.action-right-cell) {
    width: 10% !important;
}
    .table-container :deep(.actions-container){
        display: flex !important;
        flex-direction: row;
    }
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        width:45%;
        height: 35px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:25%;
        height: 100%;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
            width:33% !important;
        }
        .table-container :deep(thead :nth-child(2)){
            width:16% !important;
        }
        .table-container :deep(.wide-action-col) {
            width: 51% !important;
        }
        .table-container :deep(.action-left-cell),
        .table-container :deep(.action-right-cell) {
            width: 11% !important;
        }
        .table-container :deep(.table-action-text) {
            width: 39% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>